<template>
  <div class="topic-metadata p-3 metadata-section">
    <!-- Stats -->
    <div class="stats-container">
      <b-tag type="is-primary is-light">
        <b-icon icon="chess-board" />
        <span>{{ scenarioCount }} example</span>
      </b-tag>

      <TopicStatusBadge v-if="topic.status" :status="topic.status" />

      <DifficultyBadge
        v-if="topic.difficultyLevel"
        :difficulty="topic.difficultyLevel"
      />
    </div>

    <!-- Tags -->
    <div v-if="topic.tags && topic.tags.length" class="tags-container mt-2">
      <b-tag
        v-for="tag in topic.tags"
        :key="tag"
        type="is-light is-info"
        class="mr-1 mb-1"
      >
        {{ tag }}
      </b-tag>
    </div>

    <!-- Description -->
    <div v-if="topic.description" class="description-container mt-3">
      <p class="description-text">{{ topic.description }}</p>
    </div>

    <!-- Resources -->
    <div class="resources-container mt-3">
      <!-- Videos -->
      <div
        v-if="topic.urls && topic.urls.length"
        class="resource-section mb-2"
      >
        <a
          v-for="(url, index) in topic.urls"
          :key="index"
          :href="url"
          target="_blank"
        >
          <b-tag type="is-info is-light" size="is-small">
            <b-icon icon="video" size="is-small" class="mr-1" />
            <span class="video-link">Video {{ index + 1 }}</span>
          </b-tag>
        </a>
      </div>

      <!-- Workbook -->
      <div v-if="topic.workbookRef" class="resource-section">
        <b-tag type="is-success is-light" size="is-small">
          <b-icon icon="book" size="is-small" />
          <span>{{ topic.workbookRef }}</span>
        </b-tag>
      </div>
    </div>
  </div>
</template>

<script>
import DifficultyBadge from "@/components/training/explorer/atoms/DifficultyBadge";
import TopicStatusBadge from "@/components/training/explorer/atoms/TopicStatusBadge";

export default {
  name: "TopicMetadata",

  components: {
    DifficultyBadge,
    TopicStatusBadge,
  },

  props: {
    topic: {
      type: Object,
      required: true,
    },
    scenarioCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.topic-metadata {
  border-bottom: 1px solid #dbdbdb;
}

.metadata-section {
  flex-shrink: 0; /* Prevents the metadata section from shrinking */
  max-height: 30%; /* Limits the height of the metadata section */
  overflow-y: auto; /* Makes it scrollable if content is too large */
}

.stats-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.description-text {
  font-size: 0.9rem;
  line-height: 1.5;
  color: #4a4a4a;
}

.resources-container {
  border-top: 1px solid #f0f0f0;
  padding-top: 0.75rem;
}

.resource-section {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 0.75rem;
}

.video-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 480px) {
  .stats-container {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
